'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'bags-shopping';
var width = 576;
var height = 512;
var aliases = [128717];
var unicode = 'f847';
var svgPathData = 'M144 96c0-44.2 35.8-80 80-80s80 35.8 80 80l0 64-160 0 0-64zm-16 64l-64 0c-35.3 0-64 28.7-64 64L0 416c0 35.3 28.7 64 64 64l96 0 0-16-96 0c-26.5 0-48-21.5-48-48l0-192c0-26.5 21.5-48 48-48l320 0c26.5 0 48 21.5 48 48l16 0c0-35.3-28.7-64-64-64l-64 0 0-64c0-53-43-96-96-96s-96 43-96 96l0 64zM512 272c26.5 0 48 21.5 48 48l0 128c0 26.5-21.5 48-48 48l-256 0c-26.5 0-48-21.5-48-48l0-128c0-26.5 21.5-48 48-48l256 0zM192 320l0 128c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-128c0-35.3-28.7-64-64-64l-256 0c-35.3 0-64 28.7-64 64zm128 8c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 40c0 44.2 35.8 80 80 80s80-35.8 80-80l0-40c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 40c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-40z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBagsShopping = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;